import { actionTypes } from "modules/common";
import React, { useContext } from "react";
import { Filter, ToggleSwitch } from "../";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: number[];
}

export const ActionFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="AKCIJA"
        >
            {Object.keys(actionTypes).map((key, index, arr) => (
                <div key={index}>
                    <ToggleSwitch
                        value={actionTypes[key].value.toString()}
                        checked={value.includes(actionTypes[key].value)}
                        onChange={onChange}
                        htmlFor={actionTypes[key].label}
                        text={
                            <div
                                className={
                                    lowVision ? "low-vision-white-text" : "filter__item__text"
                                }
                            >
                                {actionTypes[key].label}
                            </div>
                        }
                    />
                </div>
            ))}
        </Filter>
    );
};
